import { render, staticRenderFns } from "./CamstudyPreview.vue?vue&type=template&id=0c26b45c&scoped=true&"
import script from "./CamstudyPreview.vue?vue&type=script&lang=js&"
export * from "./CamstudyPreview.vue?vue&type=script&lang=js&"
import style0 from "./CamstudyPreview.vue?vue&type=style&index=0&id=0c26b45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26b45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c26b45c')) {
      api.createRecord('0c26b45c', component.options)
    } else {
      api.reload('0c26b45c', component.options)
    }
    module.hot.accept("./CamstudyPreview.vue?vue&type=template&id=0c26b45c&scoped=true&", function () {
      api.rerender('0c26b45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/coordi/CamstudyPreview.vue"
export default component.exports